import { nextjsPlugin } from '@datadog/browser-rum-nextjs';
import { datadogRum } from '@datadog/browser-rum';

import { shouldSendRumEvent } from './utils';

export const initDatadog = () => {
  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID!,
    clientToken: process.env.NEXT_PUBLIC_DATADOG_RUM_CLIENT_TOKEN!,
    site: 'datadoghq.com',
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
    env: process.env.NEXT_PUBLIC_BFF_ENV,
    version: process.env.NEXT_PUBLIC_RELEASE_VERSION,
    sessionSampleRate: 1,
    sessionReplaySampleRate: 1,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend: shouldSendRumEvent,
    plugins: [nextjsPlugin()],
    allowedTracingUrls: [
      {
        match: function (url: string) {
          return url.includes('search-bff');
        },
        propagatorTypes: ['tracecontext'],
      },
      {
        match: function (url: string) {
          return url.includes('search-api');
        },
        propagatorTypes: ['tracecontext'],
      },
    ],
  });
};
